module.exports = __webpack_public_path__ + "static/media/sorghum_bicolor.whole_plant.120316d8.svg";